/**
 * Los chips de profesional, debajo de Día / Semana / Mes (spec 024 · FR-005).
 * Centrados sobre la tabla: es el medio de la rejilla, no el de la página.
 */
import { ChipFiltro } from './calendario-filtros'

export function FilaProfesionalesCalendario({
    profesionales,
    ocultos,
    alAlternar,
    alVerTodos,
    vigentesPorProf,
}: {
    profesionales: { id: number; nombre: string; color: string }[]
    ocultos: Set<number>
    alAlternar: (id: number) => void
    alVerTodos: () => void
    /** Spec 044 · vigentes suyas en lo pintado. */
    vigentesPorProf?: ReadonlyMap<number, number>
}) {
    if (profesionales.length === 0) return null
    return (
        <div className="flex flex-wrap items-center justify-center gap-1.5">
            {profesionales.map((p) => (
                <ChipFiltro
                    key={p.id}
                    activo={!ocultos.has(p.id)}
                    color={p.color}
                    onClick={() => alAlternar(p.id)}
                >
                    {p.nombre || `Profesional ${p.id}`}
                    {vigentesPorProf && (
                        <span className="tabular-nums text-neutral-400">
                            {vigentesPorProf.get(p.id) ?? 0}
                        </span>
                    )}
                </ChipFiltro>
            ))}
            {ocultos.size > 0 && (
                <button
                    type="button"
                    onClick={alVerTodos}
                    className="ml-1 text-[11px] text-sky-400 underline decoration-dotted hover:text-sky-300"
                >
                    ver todos
                </button>
            )}
        </div>
    )
}
